import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React from "react";

import { useImpersonation } from "../../../hook/useImpersonation";

const Impersonation = ({ isCurrentlyImpersonating, currentUser }) => {
  const { handleStopImpersonating, isApiLoading } = useImpersonation();

  const handleStopImpersonateClick = async () => {
    await handleStopImpersonating();
  };

  return (
    <>
      {isCurrentlyImpersonating && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            mb: 4,
            bgcolor: "#fff3e0",
            border: "1px solid #ffb74d",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography
            variant="body1"
            sx={{ fontWeight: "medium", color: "#e65100" }}
          >
            You are currently impersonating:{" "}
            <strong>
              {currentUser?.instituteName ||
                currentUser?.Fname ||
                currentUser?.Lname ||
                currentUser?.Email}
            </strong>
          </Typography>

          <Button
            variant="contained"
            color="error"
            onClick={handleStopImpersonateClick}
            size="small"
            disabled={isApiLoading}
            sx={{
              minWidth: "120px",
              ml: { xs: 0, sm: 2 },
            }}
          >
            Switch Back
            {isApiLoading && (
              <CircularProgress
                size={24}
                sx={{ color: "white", marginRight: 0, marginLeft: 0.5 }}
              />
            )}
          </Button>
        </Box>
      )}
    </>
  );
};

export default Impersonation;
